import { initCommerceApiWithGlobals } from 'common-api';
import { isBrowser, logger } from 'common-ui';
import { getRecoil, setRecoil } from 'recoil-nexus';
import { authAtom, reloadAuthToken } from '../../atoms/authAtom';
import { commerceApiExtraConfig, cartAtom } from '../../atoms/cartAtom';
import { commonHandlerForWebApiRequestError } from '../../helpers/commonHandlerForWebApiRequestError';
import { handlePromoCodeValidation } from '../../helpers/handlePromoCodeValidation';

// Creates new Cart (only necessary in WebApi)
export async function createNewCart(): Promise<void> {
  async function doCreateCart(): Promise<void> {
    if (!isBrowser()) {
      logger.log('createNewCart skipping as not in browser');
      return;
    }

    let authAtomState = getRecoil(authAtom);

    // If public CSRF is not available in state, then fetch from /pagereload endpoint
    if (!authAtomState?.publicCsrf) {
      authAtomState = (await reloadAuthToken()) || authAtomState;
    }

    const commerceApi = initCommerceApiWithGlobals(commerceApiExtraConfig(authAtomState.publicCsrf));

    const promoData = handlePromoCodeValidation();

    const newCartCreationData = await commerceApi.CartPreferences.createNewCart(promoData);
    setRecoil(cartAtom, prevState => ({
      ...prevState,
      cartIsLoaded: true,
      cartItems: {
        ...prevState.cartItems,
        ...newCartCreationData,
      },
    }));
  }

  try {
    await doCreateCart();
  } catch (e: any) {
    return commonHandlerForWebApiRequestError(e, doCreateCart);
  }
}
